import { Icon } from '@coop/components';
import { MinusIcon } from '@coop/icons';
import classNames from 'classnames';
import * as React from 'react';

import styles from './NumericStepper.module.scss';

const NumericStepperSubtractButton = React.forwardRef<
    HTMLButtonElement,
    React.ComponentPropsWithoutRef<'button'>
>((props, ref) => {
    const { className, ...otherProps } = props;

    return (
        <button
            ref={ref}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...otherProps}
            type="button"
            className={classNames(styles.Button, styles['Button--subtract'], className)}
            aria-label={props['aria-label'] || 'Minska antal'}
            data-testid="numericstepper-subtractbutton"
        >
            <Icon icon={<MinusIcon />} aria-hidden size="medium" />
        </button>
    );
});

export default NumericStepperSubtractButton;
